/**
 * explanation-graph.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Graph, GraphEdge, GraphNode } from "./graph";

import { AlgorithmStep } from "../algorithms/structure/algorithm-step";

export class ExplanationGraph extends Graph<ExplanationNode, GraphEdge>
{
  public readonly directed : boolean = true;
}

type StepType = "IntakeStep" | "ComputationStep" | "ReportStep";
export class ExplanationNode extends GraphNode
{
  public category : StepType;
  public step : AlgorithmStep;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/graphs/explanation-graph.ts